export const getCurrencySymbol = (code) => {
  switch (code) {
    case "KWD":
      return { ar: "د.ك", en: "KWD" };
    case "SAR":
      return { ar: "﷼", en: "SAR" };
    case "BHD":
      return { ar: "د.ب", en: "BHD" };
    case "AED":
      return { ar: "د.إ", en: "AED" };
    case "QAR":
      return { ar: "ر.ق", en: "QAR" };
    case "OMR":
      return { ar: "ر.ع", en: "OMR" };
    case "JOD":
      return { ar: "د.أ", en: "JOD" };
    case "EGP":
      return { ar: "ج.م", en: "E£" };
    case "USD":
      return { ar: "دولار", en: "$" };
    case "EUR":
      return { ar: "يورو", en: "€" };
    case "TRY":
      return { ar: "₺", en: "TRY" };
    case "GBP":
      return { ar: "ج.إ", en: "£" };
    case "DZD":
      return { ar: "د.ج", en: "DZD" };
    case "SYP":
      return { ar: "ل.س", en: "SYP" };
    case "MAD":
      return { ar: "د.م", en: "MAD" };
    default:
      return { ar: code, en: code };
  }
};

export const getCurrencyAndLanguageSymbol = () => {
  const currencyCode = localStorage.getItem("currency") || "KWD";
  const language = localStorage.getItem("language") || "en";
  const symbol = getCurrencySymbol(currencyCode);
  return symbol[language];
};
